import React, { CSSProperties } from "react";

import { PartnerOfferingLocation } from "../data/partner_offering";
import { useI18n } from "../lib/i18n/i18n_provider";
import { Picker } from "./picker";
import { useAnalytics } from "../lib/analytics/analytics";

interface LocationSpacePickerProps {
  locations: PartnerOfferingLocation[];
  value?: string;
  disabled?: boolean;
  onChange: (spaceID: string) => void;
  override?: {
    root?: { style?: CSSProperties };
    view?: { style?: CSSProperties };
    arrow?: { style?: CSSProperties };
  };
}

export function LocationSpacePicker(props: LocationSpacePickerProps) {
  const { disabled, value, locations, onChange, override } = props;
  const { fbt } = useI18n();
  const options = locations.map((l) => ({
    label: l.locationDisplay
      ? l.locationDisplay
      : `${l.location.city} - ${l.location.streetAddress}`,
    value: l.spaceID,
  }));

  const space = locations.find((l) => l.spaceID === value);
  const analytics = useAnalytics();

  return (
    <Picker
      icon="map-pin"
      placeholder={fbt("Select a location")}
      title={space?.location.city}
      description={space?.location.streetAddress}
      value={value}
      options={options}
      onChange={(spaceID) => {
        onChange(spaceID);

        const pl = locations.find((l) => l.spaceID === spaceID);

        if (!pl) {
          return;
        }

        analytics.event(
          "Location Select Click",
          {
            "Location UUID": pl.location.id,
            "Location Name": pl.location.name,
            Source: "WL",
          },
          { onlyProviders: ["mixpanel", "customerio"] }
        );
      }}
      disabled={disabled}
      override={override}
    />
  );
}
